module.exports = __webpack_public_path__ + "travis-screenshot.png";